import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

/**
 * Hero Class.
 */
export default class Parallax extends withBreakpointObserver(Base) {
  static config = {
    name: 'Parallax',
    refs: ['media'],
    options: {
      inactiveBreakoints: {
        type: String,
        default: 'xxs xs s m',
      },
    },
  };

  /**
   *
   */
  mounted() {
    if (!this.$refs.media) {
      this.$terminate();
      return;
    }
    this.initParallax();
  }

  /**
   *
   */
  initParallax() {
    const scale = gsap.getProperty(this.$refs.media, 'scale');
    const mediaHeight = this.$refs.media.offsetHeight;
    const overflow = (mediaHeight * scale - mediaHeight) / 2;

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.$el,
        start: 'top top',
        end: 'bottom top',
        scrub: true,
      },
    });

    tl.to(this.$refs.media, { y: -overflow, ease: 'none' }, 0);
  }
}
